// extracted by css-extract-rspack-plugin
export default {"dialog":"dialog-o79Amr","lead":"lead-bUIgyj","body":"body-Ss2Co7","startLink":"startLink-FSCX6p"};